export default __webpack_public_path__ + "static/tech3-d48e218167a19525e9ae74c5c65939b5.mp4";